export default __webpack_public_path__ + "static/media/IMG_4900.e4901541.jpg";